import { reduxStoreTypes } from '@type/redux-store';
import GlobalConfig from '@utils/global';
export const ADD_TAB:reduxStoreTypes.TabType = 'ADD_TAB';
export const DELETE_TAB:reduxStoreTypes.TabType = 'DELETE_TAB';
export const addTab = (params: Omit<reduxStoreTypes.TabAction, 'type'>) => (dispatch: any) => {
    const location = new GlobalConfig().getLocation()
    const pathname = location?.pathname;
    dispatch({
        type: ADD_TAB,
        pathname,
        params
    })
}
export const deleteTab = (params: Omit<reduxStoreTypes.RemoveTabAction, 'type'>) => (dispatch: any, getState: any) => {
    const { tabs } = getState();
    const globalConfig = new GlobalConfig()
    const location = globalConfig.getLocation()
    const navigate = globalConfig.getNavigate()
    const aliveScope = globalConfig.getAliveScope()
    const curPath = location?.pathname;
    const {
        pathname = curPath,
        removePath, 
        nextToPathname, 
        reload,
    } = params
    const tabIndex = tabs.findIndex((route: RouteConfig) => route.path === removePath); // 要关闭的tab的位置
    const curIndex = tabs.findIndex((route: RouteConfig) => route.path === pathname); // 当前路由的tab的位置
    if (tabIndex >= 1) { // 首页tab不能被删除
        //关闭当前路由
        if (tabIndex === curIndex) {
            if (!!nextToPathname) {
                if (reload) {
                    //清除即将前往下一个页面的缓存
                    aliveScope?.dropScope(nextToPathname);
                }
                setTimeout(() => {
                    navigate(nextToPathname); // 缺少search
                }, 0)
            } else {
                //前往前一个tab的模块
                const path = tabs[tabIndex - 1]['path']; 
                navigate({
                    pathname: path,
                    search: tabs[tabIndex - 1]['params']?.search
                })
            }
        }else{//不是关闭当前路由 
            //也需要清楚当前tab的缓存
            aliveScope?.dropScope(tabs[tabIndex].path);
        }
    }
    dispatch({
        type: DELETE_TAB,
        ...params,
        tabIndex,
    })
}